import React, { useState } from "react";
import FeatureUpgradePrompt from "../atoms/FeatureUpgradePrompt";
import { ModalShell } from "../atoms/ModalShell";
import { PremiumBenefit } from "../atoms/UpgradePromptContent";
import { PlansModal } from "./PlansModal";
import { PlanTier } from "../../utils/permissions";

export interface UpgradeModalProps {
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  targetPlan?: PlanTier;
  title?: string;
  description?: string;
  benefits?: PremiumBenefit[];
  icon?: React.ComponentType<any>;
  iconTheme?: "yellow" | "blue" | "purple" | "green";
  upgradeText?: string;
}

export default function UpgradeModal({
  showModal,
  setShowModal,
  targetPlan,
  title,
  description,
  benefits,
  icon,
  iconTheme = "yellow",
  upgradeText,
}: UpgradeModalProps) {
  const [showPlansModal, setShowPlansModal] = useState(false);

  const handleUpgrade = () => {
    setShowModal(false);
    setShowPlansModal(true);
  };

  return (
    <>
      <ModalShell
        show={showModal}
        onClose={() => setShowModal(false)}
        size="2xl"
        bareCloseButton
      >
        <FeatureUpgradePrompt
          flat
          title={title}
          description={description}
          benefitObjects={benefits}
          icon={icon}
          iconTheme={iconTheme}
          upgradeText={upgradeText}
          onUpgrade={handleUpgrade}
          onCancel={() => setShowModal(false)}
        />
      </ModalShell>

      <PlansModal
        showPlansModal={showPlansModal}
        setShowPlansModal={setShowPlansModal}
        targetPlan={targetPlan}
      />
    </>
  );
}
